import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=dc836200&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc836200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc836200')) {
      api.createRecord('dc836200', component.options)
    } else {
      api.reload('dc836200', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=dc836200&scoped=true", function () {
      api.rerender('dc836200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/LineChart.vue"
export default component.exports